import {
	Address,
	CustomsContentType,
	CustomsInfo,
	CustomsItem,
	DimensionUnit,
	Parcel,
	Party,
	ShipmentDeliveryService,
	ShipmentRegistrationForm,
	WeightUnit,
} from '../../@posturinn/client-react';
import { isItemWeightRequired } from '../../components/registerShipment/registerShipmentForm/stepExport/stepExportForm/helpers';
import {
	OPTIONAL_SERVICE_DELIVERY_ADVICE,
	OPTIONAL_SERVICE_DELIVER_TO_ADDRESS,
	OPTIONAL_SERVICE_EXPRESS,
	OPTIONAL_SERVICE_FRAGILE,
	OPTIONAL_SERVICE_INSURANCE,
	RecipientPays,
} from '../../constants/data/registerShipmentData';
import IDomesticShipmentDataModel from '../../interfaces/apiModels/domesticShipmentDataModel';
import IPostAdditionalService from '../../interfaces/forms/postAdditionalService';
import { IRegisterShipmentReducer } from '../../reducers/registerShipmentReducer';
import {
	normalizeShipmentPhoneForMobiz,
	normalizeShipmentPhoneForDestination,
} from '../formHelpers/formHelpers';
import { nullIfEmptyString } from '../stringHelpers/stringHelpers';
import { getCurrentLangPretty } from '../url/urlHelpers';
import { OPTIONAL_SERVICE_COD } from './../../constants/data/registerShipmentData';

export const getDomesticShipmentDataModel = (reducer: IRegisterShipmentReducer): IDomesticShipmentDataModel => {
	const { stepTypeFormInfo, stepInfoFormInfo, stepOptionalServicesFormInfo, stepShipmentFormInfo } = reducer;

	const model: IDomesticShipmentDataModel = {
		Cod: {
			Account: nullIfEmptyString(stepOptionalServicesFormInfo.codAccount),
			AccountType: nullIfEmptyString(stepOptionalServicesFormInfo.codAccountType),
			Amount: nullIfEmptyString(stepOptionalServicesFormInfo.codAmount),
			Bank: nullIfEmptyString(stepOptionalServicesFormInfo.codBank),
			CodAccOwner: nullIfEmptyString(stepOptionalServicesFormInfo.codSsn),
			Slipnumber: nullIfEmptyString(stepOptionalServicesFormInfo.codReference),
		},
		Insurance: {
			Amount: nullIfEmptyString(stepOptionalServicesFormInfo.insuranceAmount),
		},
		MailType: stepShipmentFormInfo.serviceOption,
		NumberOfItems: stepTypeFormInfo.parcelCount,
		OptionalServices: {
			CodChosen: stepOptionalServicesFormInfo.optionalServices.includes(OPTIONAL_SERVICE_COD),
			DeliverToAddressChosen: stepOptionalServicesFormInfo.optionalServices.includes(
				OPTIONAL_SERVICE_DELIVER_TO_ADDRESS
			),
			DeliveryAdviceChosen: stepOptionalServicesFormInfo.optionalServices.includes(
				OPTIONAL_SERVICE_DELIVERY_ADVICE
			),
			ExpressChosen: stepOptionalServicesFormInfo.optionalServices.includes(OPTIONAL_SERVICE_EXPRESS),
			FragileChosen: stepOptionalServicesFormInfo.optionalServices.includes(OPTIONAL_SERVICE_FRAGILE),
			InsuranceChosen: stepOptionalServicesFormInfo.optionalServices.includes(OPTIONAL_SERVICE_INSURANCE),
		},
		RecipientCanPayFee: false,
		Sendandi: {
			Gsm: nullIfEmptyString(normalizeShipmentPhoneForMobiz(stepInfoFormInfo.senderPhone)),
			Heimilisfang: nullIfEmptyString(stepInfoFormInfo.senderAddress),
			Kennitala: nullIfEmptyString(stepInfoFormInfo.senderSsn),
			Nafn: nullIfEmptyString(stepInfoFormInfo.senderName),
			Netfang: nullIfEmptyString(stepInfoFormInfo.senderEmail),
			Postnumer: stepInfoFormInfo.senderPostCode
				? nullIfEmptyString(stepInfoFormInfo.senderPostCode.value)
				: null,
			Stadur: stepInfoFormInfo.senderPostCode
				? nullIfEmptyString(stepInfoFormInfo.senderPostCode.label.split(' ')[1])
				: null,
		},
		Vidtakandi: {
			Gsm: nullIfEmptyString(normalizeShipmentPhoneForMobiz(stepInfoFormInfo.receiverPhone)),
			Heimilisfang: nullIfEmptyString(stepInfoFormInfo.receiverAddress),
			Kennitala: nullIfEmptyString(stepInfoFormInfo.receiverSsn),
			Nafn: nullIfEmptyString(stepInfoFormInfo.receiverName),
			Netfang: nullIfEmptyString(stepInfoFormInfo.receiverEmail),
			Postnumer: stepInfoFormInfo.receiverPostCode
				? nullIfEmptyString(stepInfoFormInfo.receiverPostCode.value)
				: null,
			Stadur: stepInfoFormInfo.receiverPostCode
				? nullIfEmptyString(stepInfoFormInfo.receiverPostCode.label.split(' ')[1])
				: null,
		},
		VidtakandiBorgar: stepOptionalServicesFormInfo.optionalServices.includes(RecipientPays),
	};

	return model;
};

const mapToCustomsContent = value => {
	if (value === 'G') return CustomsContentType.Gift;
	if (value === 'S') return CustomsContentType.CommercialSample;
	if (value === 'R') return CustomsContentType.ReturnedGoods;
	if (value === 'O') return CustomsContentType.Product;
	if (value === 'A') return CustomsContentType.Other;
	if (value === 'D') return CustomsContentType.Documents;
	return CustomsContentType.Other;
};

const mapOptionalServices = (data, stepShipmentFormInfo) => {
	const optionalServices = [];
	data.forEach(v => {
		const oService = { id: v, options: null };
		if (v === OPTIONAL_SERVICE_INSURANCE)
			// TODO skítamix
			// oService.options = {
			// 	amount: Number(stepShipmentFormInfo.insuranceAmount) || null,
			// 	currency: CurrencyCode.ISK,
			// };
			oService.options = JSON.stringify({
				amount: Number(stepShipmentFormInfo.insuranceAmount) || null,
				currency: 'ISK',
			});
		if (v === OPTIONAL_SERVICE_COD)
			// TODO skítamix
			// oService.options = {
			// 	amount: Number(stepShipmentFormInfo.codAmount) || null,
			// 	currency: CurrencyCode.ISK,
			// 	accountBank: nullIfEmptyString(stepShipmentFormInfo.codBank),
			// 	accountType: nullIfEmptyString(stepShipmentFormInfo.codAccountType),
			// 	accountNumber: nullIfEmptyString(stepShipmentFormInfo.codAccount),
			// 	accountIdentificationNumber: nullIfEmptyString(stepShipmentFormInfo.codSsn),
			// 	slipNumber: Number(stepShipmentFormInfo.codReference) || null,
			// };
			oService.options = JSON.stringify({
				amount: Number(stepShipmentFormInfo.codAmount) || null,
				currency: 'ISK',
				accountBank: nullIfEmptyString(stepShipmentFormInfo.codBank),
				accountType: nullIfEmptyString(stepShipmentFormInfo.codAccountType),
				accountNumber: nullIfEmptyString(stepShipmentFormInfo.codAccount),
				accountIdentificationNumber: nullIfEmptyString(stepShipmentFormInfo.codSsn),
				slipNumber: Number(stepShipmentFormInfo.codReference) || 0, // TODO ... || null,
			});
		optionalServices.push(oService);
	});
	return optionalServices;
};

const mapCustomsItems = (data, currency, includeWeight: boolean) => {
	const items: CustomsItem[] = [];
	data.map(item => {
		const customsItem = {
			hsTariffCode: item.hsTariffCode ?? '',
			quantity: item.amountInPackage.toString(),
			countryOfOrigin: item.countryOfOrigin?.value,
			cost: item.price.replace(/[. ]/g, ''),
			currencyCode: currency,
			description: item.contents,
		} as unknown as CustomsItem;
		if (includeWeight) {
			const lineWeight =
				parseFloat(String(item.weight ?? '').replace(',', '.')) * parseFloat(String(item.amountInPackage));
			if (Number.isFinite(lineWeight)) {
				customsItem.weight = Math.round(lineWeight * 1000) / 1000;
				customsItem.weightUnit = WeightUnit.KG;
			}
		}
		items.push(customsItem);
	});
	return items;
};

export const getInternationalShipmentDataModel = (reducer: IRegisterShipmentReducer): ShipmentRegistrationForm => {
	const { stepInfoFormInfo, stepExportFormInfo, stepShipmentFormInfo } = reducer;
	const sendingToIceland = stepInfoFormInfo.country.value === 'IS';
	const normalizePhoneForDestination = (phone?: string) =>
		normalizeShipmentPhoneForDestination(phone, stepInfoFormInfo.country.value);

	const customsInfo: CustomsInfo = new CustomsInfo({
		customsContent:
			sendingToIceland ? null : mapToCustomsContent(stepExportFormInfo.packageType?.value),
		returnPolicy: stepExportFormInfo.returnPolicy?.value,
	});

	const includeWeight = isItemWeightRequired(
		stepInfoFormInfo.country?.value,
		stepExportFormInfo.packageType?.value,
		stepShipmentFormInfo.serviceOption === 'InternationalLetter'
	);
	const cItems = stepExportFormInfo?.contents
		? mapCustomsItems(stepExportFormInfo.contents, stepExportFormInfo?.currency?.value, includeWeight)
		: null;
	cItems.forEach(item => {
		if (item && item.cost && typeof item.cost === 'string') {
			item.cost = Number(String(item.cost).replace(',', '.'));
		}
		customsInfo.customsItems.push(item);
	});

	const shipmentDeliveryService: ShipmentDeliveryService = new ShipmentDeliveryService({
		id: stepShipmentFormInfo.serviceOption,
		type: stepShipmentFormInfo.service,
		estimatedDeliveryMessage: '',
		extraServices: mapOptionalServices(stepShipmentFormInfo.optionalServices, stepShipmentFormInfo),
	});

	const recipientAddress: Address = new Address({
		street1: nullIfEmptyString(stepInfoFormInfo.receiverAddress),
		street2:
			sendingToIceland
				? null
				: nullIfEmptyString(stepInfoFormInfo.receiverForeignAddressExtended),
		city:
			sendingToIceland
				? stepInfoFormInfo.receiverPostCode
					? nullIfEmptyString(stepInfoFormInfo.receiverPostCode.label.split(' ')[1])
					: null
				: nullIfEmptyString(stepInfoFormInfo.receiverForeignPlace),
		postalCode:
			sendingToIceland
				? stepInfoFormInfo.receiverPostCode
					? nullIfEmptyString(stepInfoFormInfo.receiverPostCode.value)
					: null
				: nullIfEmptyString(stepInfoFormInfo.receiverForeignPostCode),
		country: stepInfoFormInfo.country.value,
	});

	const recipient: Party = new Party({
		identificationNumber: nullIfEmptyString(stepInfoFormInfo.receiverSsn),
		name: stepInfoFormInfo.receiverName,
		phone: nullIfEmptyString(normalizePhoneForDestination(stepInfoFormInfo.receiverPhone))
			? normalizePhoneForDestination(stepInfoFormInfo.receiverPhone)
			: normalizePhoneForDestination(stepShipmentFormInfo.receiverPhone),
		email: nullIfEmptyString(stepInfoFormInfo.receiverEmail),
		address: recipientAddress,
	});

	const senderAddress: Address = new Address({
		street1: nullIfEmptyString(stepInfoFormInfo.senderAddress),
		street2: '',
		city: stepInfoFormInfo.senderPostCode
			? nullIfEmptyString(stepInfoFormInfo.senderPostCode.label.split(' ')[1])
			: null,
		postalCode: stepInfoFormInfo.senderPostCode ? nullIfEmptyString(stepInfoFormInfo.senderPostCode.value) : null,
		country: 'IS',
	});

	const sender: Party = new Party({
		identificationNumber: nullIfEmptyString(stepInfoFormInfo.senderSsn),
		name: nullIfEmptyString(stepInfoFormInfo.senderName),
		phone: nullIfEmptyString(normalizePhoneForDestination(stepInfoFormInfo.senderPhone)),
		email: nullIfEmptyString(stepInfoFormInfo.senderEmail),
		address: senderAddress,
	});

	const parcelWeightNumber = Number(stepShipmentFormInfo.parcelWeight);
	const normalizedParcelWeight =
		stepShipmentFormInfo.service === 'Parcel' &&
		!sendingToIceland &&
		!isNaN(parcelWeightNumber)
			? Math.max(1, Math.ceil(parcelWeightNumber))
			: stepShipmentFormInfo.parcelWeight;

	const parcels: Parcel[] = [
		new Parcel({
			dimensionUnit: DimensionUnit.CM,
			weightUnit: stepShipmentFormInfo.service === 'Parcel' ? WeightUnit.KG : WeightUnit.G,
			weight: stepShipmentFormInfo.dontKnowWeight ? null : normalizedParcelWeight,
			width: Number(stepShipmentFormInfo.parcelWidth) || null,
			height: Number(stepShipmentFormInfo.parcelHeight) || null,
			length: Number(stepShipmentFormInfo.parcelLength) || null,
		}),
	];

	const model: ShipmentRegistrationForm = new ShipmentRegistrationForm({
		recipient: recipient,
		sender: sender,
		deliveryService: shipmentDeliveryService,
		selectedDeliveryLocation:
			stepShipmentFormInfo.serviceOption === 'ParcelPoint'
				? stepShipmentFormInfo.serviceOptionParcelpoint.value
				: stepShipmentFormInfo.serviceOption === 'Postbox'
				? stepShipmentFormInfo.serviceOptionPostbox.value
				: null,
		customsInfo: stepInfoFormInfo.country?.value === 'IS' ? null : customsInfo,
		numberOfParcels: stepShipmentFormInfo.parcelCount,
		recipientPaysShippingFee: stepShipmentFormInfo.optionalServices.includes(RecipientPays),
		parcels: parcels,
		deliverTo: stepInfoFormInfo.receiverForeignShipTo,
		chargeSenderCard: stepInfoFormInfo.chargeSenderCard,
	});

	return model;
};

export const getInsuranceFormCustomPrice = (value: string) => {
	const numberVal = isNaN(Number(value)) ? 0 : Number(value);
	const price = numberVal > 100000 ? Math.round(numberVal * (0.5 / 100)) : 0;

	return price;
};

export const getCodFormCustomPrice = (value: string) => {
	const numberVal = isNaN(Number(value)) ? 0 : Number(value);
	const price = numberVal > 30000 ? Math.round(numberVal * 0.025) : 0;

	return price;
};

export const getOptionalServicesTotalAmount = (
	selectedOptionalServices: string[],
	optionalServices: IPostAdditionalService[],
	insuranceCustomPrice: number,
	codCustomPrice: number
) => {
	const total = selectedOptionalServices.reduce((acc, curr) => {
		// There are optional services selected but no services available
		if (optionalServices === null) return acc;
		const service = optionalServices.find(x => x.serviceCode === curr);
		// Service not found
		if (!service) return acc;

		let price = service.priceWithoutCommas;

		if (service.serviceCode === OPTIONAL_SERVICE_INSURANCE && insuranceCustomPrice !== 0) {
			price = insuranceCustomPrice;
		} else if (service.serviceCode === OPTIONAL_SERVICE_COD && codCustomPrice !== 0) {
			price = codCustomPrice;
		}

		return (acc += price);
	}, 0);

	return total;
};

export const getPostcodeLabel = (postcode, postCodes) => {
	for (let i = 0; i < postCodes.length; i++) if (postCodes[i].value === postcode) return postCodes[i].label;
	return postcode;
};

export const getCountry = (countryCode, countries) => {
	if (countries && countryCode)
		for (let i = 0; i < countries.length; i++)
			if (countries[i].value.toUpperCase() === countryCode.toUpperCase()) return countries[i];
	return { value: 'IS', label: getCurrentLangPretty() === 'is' ? 'Ísland' : 'Iceland' };
};
